var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawLearningQt7D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 394.273,
    height: 800.22,
    viewBox: "0 0 394.273 800.22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-872.203 -226.154)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(872.203 367.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.593,196.85c-8.1-8.243-18.918-10.745-24.162-5.589s-2.93,16.015,5.174,24.259a28.921,28.921,0,0,0,11.5,7.363l34.759,34.491L218.7,240.717l-35.948-32.233a28.922,28.922,0,0,0-7.165-11.634Z",
    transform: "translate(-85.591 -64.425)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.123,176.294l-36.444,80.849-58.2-31.5L74.656,236.7s47.573,79.534,80.147,70.48S245.219,216.027,234.8,190.69s-44.675-14.4-44.675-14.4Z",
    transform: "translate(11.042 -72.339)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.294,561.156l-26.574,0-12.64-102.5,39.22,0Z",
    transform: "translate(83.851 81.622)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.358,535.312h0c-.827,1.393-1.264,5.891-1.264,7.512h0a9.019,9.019,0,0,0,9.019,9.019h82.295a6.153,6.153,0,0,0,6.153-6.153v-3.426s4.071-10.3-4.311-22.99c0,0-10.417,9.938-25.983-5.628l-4.59-8.316-33.227,24.3L101.033,531.9c-4.029.5-7.6-.077-9.674,3.414Z",
    transform: "translate(34.743 106.863)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.076,196.252l-.536-35.841,22.1-13.779,24.033,29.4Z",
    transform: "translate(118.96 -87.109)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.308,
    cy: 39.308,
    rx: 39.308,
    ry: 39.308,
    transform: "translate(157.66 5.838)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.156,353.527,116.773,602.7h45.941l-6.109-142.236-3.215-74.789,9.324-35.6a159,159,0,0,0,7.832-17.5c4.037-10.824,7.225-23.8,2.492-29.955-1.742-2.269-6.27-3.948-12.423-5.2a128.547,128.547,0,0,0-12.861-1.831c-27.168-2.688-65.813-1.009-65.813-1.009L80.959,327l-.545,18.1-.259,8.422Z",
    transform: "translate(63.204 -7.383)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.409,552.864l-26.29,3.863L63.7,457.156l38.8-5.7Z",
    transform: "translate(146.545 77.728)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.823,539.021h0c-.616,1.5-.394,6.012-.158,7.616h0A9.019,9.019,0,0,0,69.9,554.248l81.42-11.97a6.153,6.153,0,0,0,5.192-6.982l-.5-3.39s2.53-10.78-7.609-22.118c0,0-8.861,11.348-26.525-1.788l-5.751-7.559L86.79,529.314,68.9,534.236c-3.914,1.077-7.532,1.03-9.075,4.785h0Z",
    transform: "translate(113.969 104.218)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.55,314.142,67.573,357.4l27.39,91.145L140.05,598.6l45.448-6.679L144.709,378.56l4.039-36.585s1.315-3.637,2.823-8.961c2.993-10.533,6.746-27.685,2.617-36.435a10.229,10.229,0,0,0-2.123-3.057c-1.624-1.575-4.925-2.532-9.348-3.039-18.486-2.089-56.556,3.886-73.5,6.82l-6.67,16.839Z",
    transform: "translate(80.233 -9.554)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.935,160.791,121.28,182.226S73.945,322.443,73.945,329.588s-13.4,11.61-5.359,19.648S53.626,364.082,66.018,370.5s89.7,41.54,98.295,38.373c23.708-8.735-1-40.831-1-40.831s17.809-14.342,15.13-21.487,16.076-143.79,16.076-143.79l-28.579-41.976Z",
    transform: "translate(71.647 -79.452)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.77,162.561l-5.056,10.112s-5.056-18.2-13.145-22.246-9.1-10.112-9.1-10.112-10.112,13.145-17.19,10.112-10.112-5.056-2.022-17.19,6.067-6.067,6.067-6.067,7.078-10.112,6.067-7.078,6.067-8.089,6.067-5.056,5.056-6.067,5.056-3.033,21.234-7.078,18.2-3.033,18.2-8.089,28.313,8.089c3.681,5.889,13.994,23.257,13.994,23.257l.468,29.325-9.608,8.088s-16.989-27.3-28.111-15.167Z",
    transform: "translate(70.598 -108)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 137.646) rotate(-19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.7,82.656,46.78,118.834,0,36.178,63.923,0Z",
    fill: "#0284C7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.386,
    height: 6.768,
    rx: 3.384,
    transform: "matrix(0.87, -0.493, 0.493, 0.87, 27.887, 50.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.386,
    height: 6.768,
    rx: 3.384,
    transform: "matrix(0.87, -0.493, 0.493, 0.87, 36.553, 66.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.386,
    height: 6.768,
    rx: 3.384,
    transform: "matrix(0.87, -0.493, 0.493, 0.87, 45.219, 81.483)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.04,241.441c-11.082-3.274-21.755-.21-23.838,6.843s5.213,15.423,16.3,18.7a28.92,28.92,0,0,0,13.632.853l47.132,13.28,5.76-22.25-47.075-10.729a28.923,28.923,0,0,0-11.911-6.693Z",
    transform: "translate(-53.527 -36.549)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.287,195.028l7.387,88.375-66.17.712L77.662,303.889s80.2,46.439,104.284,22.71,34.8-123.581,13.386-140.673S149.287,195.028,149.287,195.028Z",
    transform: "translate(35.591 -68.991)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 1214.149, 238.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.964,35.982a43.659,43.659,0,0,1-.7,7.784,38.227,38.227,0,0,1-3.782,9.377c-3.2,5.684-6.631,7.806-9.451,13.372-.485.375-.984.712-1.491,1.043-1.013.654-1.124,3.855-2.2,4.406-.007.007-.015.007-.022.015a4.069,4.069,0,0,0-.558,1.851v.015c-.543,3.18-1.013,9.649-1.557,13.475-.073.463-.14.889-.213,1.263-.184,1.013-.374,1.66-.587,1.74-2.622,1.013-3.738-.375-6.609,0-1.542.206-9.414,1.469-11.015,1.469-4.545,0-7.005-1.549-10.684-3.209-.257-.11-.514-.228-.786-.345-.1-.037-.183-.081-.279-.117-1.057-.448-2.056-11.742-3.047-16.016a.027.027,0,0,1-.007-.022c-.206-.889-.411-1.469-.617-1.586l-.154-.088c-.654-.375-1.292-.786-1.917-1.212C12.506,62.895,5.2,56.9,1.593,47.1A41.3,41.3,0,0,1,0,35.982a35.982,35.982,0,1,1,71.963,0Z",
    transform: "translate(0.542 19.347)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.808,45.178a38.23,38.23,0,0,1-3.782,9.377c-3.2,5.684-6.631,7.806-9.451,13.372C56.7,71.635,55.1,76.871,54.008,85.7c-.066.521.073,1.116,0,1.63-.169,1.138.037.933-.654,1.961-.316.176-.507-.073-.609-.558a15.332,15.332,0,0,1-.044-3.686,48.542,48.542,0,0,1,1.6-9.789v-.015c.176-.639.367-1.256.558-1.85,3.4-10.354,9.671-15.046,12.513-20.466C82.3,24.521,54.713-7.187,24.327,3.843c-1.63.595-1.542.94-1.63.984-2.284.991-4.141,1.425-6.359,2.93C2.87,16.921-1.962,35.051,4.111,49.987,7.4,58.072,14.289,62.632,18.746,71.819q.4.8.771,1.674a.027.027,0,0,0,.007.022,44.893,44.893,0,0,1,3.327,16.133c.007.1.015.191.015.286.264.022.521.037.771.059,3.9.338,6.425.962,7.733.286l1.439.147c.477.668,8.5-.147,9.781-.162h.33a89.411,89.411,0,0,0,9.612-.272c.162-.015.33-.037.492-.059a.859.859,0,0,1,.654.984c.1.925-1.432,3.605-1.953,3.907-1.505.881-26.032,1.329-28.374-.323a3.68,3.68,0,0,1-1.3-4.4c-.044-.206-.947-.793-.984-.984-.44-2.5.081-8.834-2.93-15.979a19.281,19.281,0,0,0-1.307-2.533c-3.782-6.3-11.088-12.293-14.694-22.1A36.662,36.662,0,0,1,.2,32.055C1.5,18.25,13.408,4.665,26.772,1.236c27.97-7.182,51.586,18.182,45.036,43.942Z",
    transform: "translate(0 17.935)",
    fill: "#010001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,0c2.327,2.214,1.084,2.963,0,5.544-1.368-.308-24.783,1.189-28.045,0A3.323,3.323,0,0,1,1.077,0,130.745,130.745,0,0,0,30.1,0Z",
    transform: "translate(21.976 113.522)",
    fill: "#010001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.96.652c.916,2.037-.837,3.287-1.631,4.892L28.7,5.87,2.937,5.544C1.382,5.245.4,3.073,0,1.631A.963.963,0,0,1,.491.652L2.61,0a231.725,231.725,0,0,0,25.6.652A3.726,3.726,0,0,1,31.96.652Z",
    transform: "translate(21.42 119.392)",
    fill: "#010001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.127,37.7h-.676V26.656L0,.289.611,0,13.127,26.5Z",
    transform: "translate(19.116 55.812)",
    fill: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.319.057C1.7-.884,1.722,10.134,1.3,10.492-.312,11.848-.143.372.319.057Z",
    transform: "translate(36.017 0)",
    fill: "#010001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.058.033c1.084-.7,3.586,9.732,3.424,10.272C2.56,13.377-.453.361.058.033Z",
    transform: "translate(25.191 1.002)",
    fill: "#010001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.107.008C3.4-.331,1.224,9.81.966,10.281-1.479,14.729,1.405.193,2.107.008Z",
    transform: "translate(45.316 1.027)",
    fill: "#010001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.554,39.489,0,27.217l.012-.047L6.621,0l.657.16L.68,27.283l.549,12.176Z",
    transform: "translate(42.213 54.04)",
    fill: "#0f0f10"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(926.582 238.21) rotate(19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.067,75.54H6.839a6.117,6.117,0,0,1-4.8-2.314A5.992,5.992,0,0,1,.862,68.135,117.592,117.592,0,0,0,.186,13.346a6.065,6.065,0,0,1,2.8-6.711c15.659-9.115,32.381-8.837,49.7.829a6.133,6.133,0,0,1,3.117,4.4,192.416,192.416,0,0,1,.33,58.418,6.1,6.1,0,0,1-6.063,5.262Z",
    transform: "translate(0.962 40.839) rotate(-42)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.971,6.2H3.1A3.1,3.1,0,0,1,3.1,0H17.971a3.1,3.1,0,1,1,0,6.2Z",
    transform: "translate(28.144 53.247) rotate(-42)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.153,6.2H3.1A3.1,3.1,0,1,1,3.1,0H36.153a3.1,3.1,0,1,1,0,6.2Z",
    transform: "translate(36.341 62.351) rotate(-42)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.507,76.9a6.761,6.761,0,0,1-5.324-2.571,6.632,6.632,0,0,1-1.3-5.665A117.051,117.051,0,0,0,3.762,41.388a117.055,117.055,0,0,0-3.553-27.2,6.744,6.744,0,0,1,3.11-7.463A47.006,47.006,0,0,1,27.158,0C35.791,0,44.72,2.54,53.7,7.55a6.766,6.766,0,0,1,3.456,4.88,192.879,192.879,0,0,1,.331,58.627A6.784,6.784,0,0,1,50.766,76.9H7.507ZM27.158,1.359A45.661,45.661,0,0,0,4.006,7.9a5.385,5.385,0,0,0-2.48,5.957A118.413,118.413,0,0,1,5.121,41.372,118.415,118.415,0,0,1,2.206,68.965a5.283,5.283,0,0,0,1.039,4.515A5.411,5.411,0,0,0,7.507,75.54H50.763a5.425,5.425,0,0,0,5.376-4.676,191.528,191.528,0,0,0-.328-58.217A5.417,5.417,0,0,0,53.039,8.74C44.262,3.841,35.557,1.359,27.158,1.359Z",
    transform: "translate(0 39.854) rotate(-42)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1048.588 226.154)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.771 0.77)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.281,
    cy: 33.281,
    r: 33.281,
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.679,54.408a3.6,3.6,0,0,0-4.879,1.279L415.933,79.2a51.547,51.547,0,0,0-12.009-13.023c-1.525-1.178-3.995-.232-4.879,1.279-1.077,1.842-.25,3.7,1.279,4.879a42.929,42.929,0,0,1,12.649,16.329c1.09,2.406,5.02,2.254,6.158,0l14.828-29.375a3.652,3.652,0,0,0-1.279-4.879h0Z",
    transform: "translate(-382.087 -40.614)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.552-.5A34.06,34.06,0,0,1,46.806,64.927,34.06,34.06,0,0,1,20.3,2.176,33.839,33.839,0,0,1,33.552-.5Zm0,66.562A32.52,32.52,0,0,0,46.206,3.6,32.519,32.519,0,0,0,20.9,63.508,32.307,32.307,0,0,0,33.552,66.062Z",
    transform: "translate(0.5 0.5)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawLearningQt7D);
export default __webpack_public_path__ + "static/media/undraw_learning_qt7d.b38d2c6c2eb05fecd07f2e57e60ccd08.svg";
export { ForwardRef as ReactComponent };